import { v4 as uuidv4 } from 'uuid';

/**
 * Generates the unique reminder ID
 */
export function generateUniqueReminderId(): string {
  const timeStamp = Date.now().toString();
  return timeStamp.concat(uuidv4());
}
